export default {
  path: '/solution',
  auth: true,
  preload: false,
  key: 'solution',
  layout: 'inner', // outer 一级菜单 inner 二级菜单
  component: () => import('./index')
};
